
const constants = Object.freeze({
    TIMEOUT: 30000,
    CLIENT_ID: '5cdf81c8-0389-43be-9e9e-ac48d7aa732d',
    WEBSITE_VERSION: 200,
    API_URL: import.meta.env.VITE_API_URL
});

export default constants;